import Heading from '../common/Heading';
import { TextWithDropShadow } from '../TextWithDropShadow';
import ReviewCard, { StrapiFlatReviewData } from './card';

export default function FlatReviews({
  data,
}: {
  data: {
    sectionTitle: {
      text: string;
      shadow: boolean;
      hidden: boolean;
      size: {
        size: string;
      };
      color: {
        color: string;
      };
    };
    sectionBody: {
      text: string;
      shadow: boolean;
      hidden: boolean;
      size: {
        size: string;
      };
      color: {
        color: string;
      };
    };
    cardGap: string;
    sectionPadding: boolean;
    data: StrapiFlatReviewData[];
  };
}) {
  const sectionTitle = data.sectionTitle;
  const sectionBody = data.sectionBody;
  const reviewData = data.data;

  const titleSize =
    (sectionTitle && sectionTitle.size?.size.match(/\d+/)?.[0]) || '2';
  return (
    <>
      <div
        className={`section-fade-2 relative flex flex-col ${data.sectionPadding ? 'gap-y-8 py-14 md:py-20 xl:py-24' : ''}`}
      >
        {sectionTitle && !sectionTitle?.hidden && (
          <>
            <div className='mx-auto mb-9 flex w-full flex-col gap-6 text-center md:w-8/12'>
              {!sectionTitle?.hidden && (
                <Heading className='mb-3' size={`${titleSize}`}>
                  <TextWithDropShadow
                    text={sectionTitle?.text || 'Title'}
                    color={{
                      text: sectionTitle?.color?.color || 'text-grey-900',
                      shadow: '',
                    }}
                    displayShadow={false}
                  />
                </Heading>
              )}
              {!sectionBody?.hidden && (
                <div className='text-base font-medium'>
                  <TextWithDropShadow
                    text={sectionBody?.text}
                    displayShadow={false}
                    color={{
                      text: sectionBody?.color?.color || 'text-grey-900',
                      shadow: '',
                    }}
                  />
                </div>
              )}
            </div>
          </>
        )}
        <div
          className={`flex w-full flex-wrap justify-center ${data.cardGap && 'gap-6 lg:gap-8'}`}
        >
          {reviewData &&
            reviewData.map((review, idx) => (
              <ReviewCard reviewBlock={review} key={idx} />
            ))}
        </div>
      </div>
    </>
  );
}
